import {Component, Input, OnChanges, OnInit, SimpleChanges, forwardRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ImportTemplateService} from '../../import-template.service';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => SettingFormComponent),
      multi: true
    }
  ]
})
export class SettingFormComponent implements OnInit, OnChanges, ControlValueAccessor {

  public form: FormGroup;
  public controlsSelect: any[];
  public controlsCheck: any[];
  public controlsInput: any[];
  public controlsMultiSelect: any[];
  public dataSelect = [];
  public idSelect = [];
  @Input() controlsForm: any;

  onChange = (_: any) => { };

  constructor(
    private fb: FormBuilder,
    private _service: ImportTemplateService
  ) {
    this.createForm();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['controlsForm'].currentValue) {
      this.createForm();
      this.createControls(this.controlsForm);
      this.chooseControlsForm(this.controlsForm);
      this.generateDataMulti();
    }
  }

  /**
   * @Metodo ControlValueAccessor
   * @description Para el comportamiento del form como campo
   * */
  registerOnChange(fn: any): void { this.onChange = fn; }
  writeValue(value: any): void { }
  registerOnTouched(fn: any): void { }
  setDisabledState(isDisabled: boolean): void { }


  /**
   * @Metodo createForm
   * @description Para crear el formulario.
   * */
  createForm() {
    this.form = this.fb.group({
      dynamicConfig: this.fb.group({
      })
    });
    this.getValueForm();
  }

  /**
   * @Metodo getDataUri
   * @description Para crear los capos del formulario dinamicamente.
   * */
  getDataUri(uri: string, i: number) {
    this._service.getTotalService(uri).subscribe(
      success => {
        this.dataSelect[i] = success;
      }
    );
  }

  /**
   * @Metodo createControls
   * @description Para crear los capos del formulario dinamicamente.
   * */
  createControls(controls) {
    controls.forEach(row => {
      if (row.type === 'checkbox') {
        this.getDinamicConfig()
          .addControl(row.name, this.fb.control(row.value, Validators.required));
      }
      if (row.type === 'dropdown') {
        this.getDinamicConfig()
          .addControl(row.name, this.fb.control('', Validators.required));
      }
      if (row.type === 'input') {
        this.getDinamicConfig()
          .addControl(row.name, this.fb.control(''));
      }
      if (row.type === 'multiDropdown') {
        this.getDinamicConfig()
          .addControl(row.name, this.fb.control(''));
      }
    });
  }

  /**
   * @Metodo getDinamicConfig
   * @description Para traer el campo dinamicConfig de tipo group
   * */
  getDinamicConfig(): FormGroup {
    return this.form.controls['dynamicConfig'] as FormGroup;
  }

  /**
   * @Metodo getValueForm
   * @description suscribe a los cambios del formulario
   * */
  getValueForm() {
    this.form.valueChanges.subscribe(val => {
      this.detecteValid(val);
    });
  }

  /**
   * @Metodo generateDataMulti
   * @description Para generar la data de los multiselect
   * */
  generateDataMulti() {
    if (this.controlsMultiSelect.length) {
    this.controlsMultiSelect.forEach((val, i) => {
      this.getDataUri(val.values.uri, i);
      this.idSelect[i] = val.values.value;
    });
    }
  }

  /**
   * @Metodo chooseControls
   * @description Para escoger los controles y separarlos
   * */
  chooseControlsForm(controlsForm) {
    this.controlsSelect = [];
    this.controlsCheck = [];
    this.controlsInput = [];
    this.controlsMultiSelect = [];
    this.controlsSelect = controlsForm.filter(
      row => {if (row.type === 'dropdown') {return row; }
      });
    this.controlsCheck = controlsForm.filter(
      row => {if (row.type === 'checkbox') {return row; }
      });
    this.controlsInput = controlsForm.filter(
      row => {if (row.type === 'input') {return row; }
      });
    this.controlsMultiSelect = controlsForm.filter(
      row => {if (row.type === 'multiDropdown') {return row; }
      });
  }

  /**
   * @Metodo detecteValid
   * @description Para validar y enviar datos del formulario
   * */
  detecteValid(val) {
    if (this.form.valid) {
      this.onChange(val.dynamicConfig);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/setting-form/setting-form.component.ts